import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useState } from "react";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleSignInButton({ linkUserId = null, label = "Iniciar sesión con Google", variant = "outline" }) {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    try {
      const params = linkUserId ? { link_user_id: linkUserId } : {};
      const { data } = await api.get("/auth/google/login", { params });
      window.location.href = data.auth_url;
    } catch (e) {
      toast.error("No se pudo iniciar el flujo de Google");
      setLoading(false);
    }
  };

  return (
    <Button type="button" variant={variant} className="w-full" onClick={onClick} disabled={loading} data-testid="google-signin-button">
      {loading ? <Loader2 size={14} className="mr-2 animate-spin"/> : (
        <svg className="mr-2" width="16" height="16" viewBox="0 0 24 24">
          <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.4-1.7 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1S8.7 5.9 12 5.9c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 3.4 14.5 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z"/>
        </svg>
      )}
      {label}
    </Button>
  );
}
